export default {"src":"/_next/static/media/KEY.50530caf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};